import optionsTailored from '../../../../../icons/optionsTailored.svg';
import scheduleAppointment from '../../../../../icons/scheduleAppointment.svg';
import reviewOptions from '../../../../../icons/reviewOptions.svg';
import submitForApproval from '../../../../../icons/submitForApproval.svg';
import activateCoverage from '../../../../../icons/activateCoverage.svg';
import choices from '../../../../../icons/choices.svg';
import lifetimeSecurity from '../../../../../icons/lifetimeSecurity.svg';

export default function PurchasingProcessData() {
    return {
        title: "Our Purchasing Process",
        subtitle: "We offer a selection of top rated companies to help secure your best value. The purchasing process can be completed in 4 easy steps.",
        steps: [
            {
                title: "Schedule an Appointment",
                icon: scheduleAppointment,
                paragraphs: [
                    "Enter your information and select an appointment date to speak with a licensed insurance expert.",
                ]
            },
            {
                title: "Review Best Choices and Options",
                icon: reviewOptions,
                paragraphs: [
                    "Our licensed insurance expert will provide you a variety of life insurance options that are customized to meet your needs and budget.",
                ]
            },
            {
                title: "Submit Your Application for Approval",
                icon: submitForApproval,
                paragraphs: [
                    "Upon selection of your life insurance coverage, we will then assist you to complete and sign your application and submit to the insurance company for final approval. Our service to you is complementary with no payment obligation for the policy until you are ready to activate your coverage.",
                ]
            },
            {
                title: "Activate Your Coverage",
                icon: activateCoverage,
                paragraphs: [
                    "Once approved, you will receive your life insurance policy to review and submit the first payment to activate your coverage.",
                ]
            },
        ],
        stepsfooter:[
            {
                title: "Choice and affordability",
                icon: choices,
                paragraphs: [
                    "As a broker, we are not beholden to only 1 insurance company. We represent a broad range of A rated companies that offer the most competitive prices. That means you get the best options to find the right coverage to meet your needs and budget.",
                ]
            },
            {
                title: "Easy application and expert service",
                icon: optionsTailored,
                paragraphs: [
                    "Our team of licensed insurance experts are knowledgeable, professional and will guide you through an easy application process as well as any underwriting requirements necessary to secure your coverage.",
                ]
            },
            {
                title: "Lifetime security",
                icon: lifetimeSecurity,
                paragraphs: [
                    "Once you activate your coverage, your prices are locked in for your lifetime and can never be increased, even if your health changes. As long as you pay your premiums on time, your policy can never be canceled.",
                ]
            },
        ]
    };
};



// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/WholeLife/PurchasingProcessData.js